import * as React from 'react';
import '../css/channel-line-up-row.sass';

interface PackageType {
  [key: string]: boolean;
}

interface ChannelLineUpRowProps {
  name: string;
  logoUrl?: string;
  isSAP?: boolean;
  sapLabel?: string;
  chLabel?: string;
  channelNumber?: string;
  packages?: PackageType;
  additionalDetails?: string[];
  orbitals?: string[];
  isPrintable?: boolean;
  isInternational?: boolean;
  hidePackages?: boolean;
  backgroundColor?: '#f5f5f4' | '#ffffff';
}

export default function ChannelLineUpRow(props: ChannelLineUpRowProps) {
  const {
    chLabel = 'Ch. ',
    sapLabel = 'SAP',
    isPrintable = false,
    isInternational = false,
    backgroundColor = '#f5f5f4',
    hidePackages = false
  } = props;

  let keyIndex = 0;

  const auxiliaryInfo = () => {
    return (
      <div className="auxiliary-info">
        {props.channelNumber && (
          <>
            <span className="channel-number">{chLabel}</span>
            {props.channelNumber
              .split(',')
              .map((number: string, index: number) => {
                keyIndex += 1;
                return (
                  <span key={keyIndex} className="channel-number">
                    {(index ? ', ' : '') + number}
                  </span>
                );
              })}
          </>
        )}
        {props.orbitals && props.orbitals.length > 0 && (
          <>
            <span className="dot" />
            <span className="sr-only">DISH Outdoors orbitals:</span>{' '}
            {/* visually-hidden content  to support screenReaders */}
            {props.orbitals.map((orbital: string, index: number) => {
              keyIndex += 1;
              return (
                <span key={keyIndex} className="orbitals">{`${(index
                  ? ', '
                  : '') + orbital}\u00B0`}</span>
              );
            })}
          </>
        )}
      </div>
    );
  };

  return (
    <>
      <div
        className={`channel-line-up-row${isPrintable ? ' printable' : ''}`}
        style={{ backgroundColor }}
      >
        <div className={`channel-line-details${isPrintable ? ' col-6' : ''}`}>
          {props.logoUrl && (!isPrintable || isInternational) && (
            <img alt="" src={props.logoUrl} />
          )}
          <div className={`channel-name${isPrintable ? ' col-3' : ''}`}>
            {props.name}
          </div>
          <div className={`ch-details${isPrintable ? ' col-9 ' : ''}`}>
            {props.isSAP && <span className="sap-label">{sapLabel}</span>}
            {props.additionalDetails &&
              props.additionalDetails.map((name: string) => {
                keyIndex += 1;
                return (
                  <span key={keyIndex} className="resolution-label">
                    {name}
                  </span>
                );
              })}
            <span className={`${isPrintable ? 'd-none' : 'd-block d-md-none'}`}>
              {/* hides this in medium/large devices */}
              {auxiliaryInfo()}
            </span>
          </div>
        </div>
        <span className="sr-only">available in:</span>{' '}
        {/* visually-hidden content  to support screenReaders */}
        <div
          className={`packages${isPrintable && !hidePackages ? ' col-3' : ''}`}
          role="list"
        >
          {!hidePackages &&
            props.packages &&
            Object.keys(props.packages).map((keyword: string) => {
              keyIndex += 1;
              return props.packages && props.packages[keyword] ? (
                <span key={keyIndex} role="listitem">
                  {!isPrintable ? keyword : ''}
                </span>
              ) : (
                <span
                  key={keyIndex}
                  aria-hidden="true"
                  className="empty-span"
                  role="listitem"
                >
                  {keyword}
                </span>
              );
            })}
        </div>
        <span
          className={`${
            isPrintable ? 'd-block col-3' : 'd-none d-md-block'
          } auxiliary-info`}
        >
          {/* hides this in smaller devices */}
          {auxiliaryInfo()}
        </span>
      </div>
    </>
  );
}
